import { CoralogixEventType } from '../types';
export const MAX_RUM_EVENTS_PER_REQUEST = 500;
export const MAX_RUM_EVENTS = 20000;
export const MAX_MS_RECORD_TIME = 60000;
export const DEFAULT_RUM_EVENTS = 5000;
export const DEFAULT_MS_RECORD_TIME = 10000;
export const DEFAULT_SESSION_WITH_ERROR_CONFIG = {
    enable: true,
    maxRumEvents: DEFAULT_RUM_EVENTS,
    maxRecordTime: DEFAULT_MS_RECORD_TIME,
    instrumentationsToSend: {
        [CoralogixEventType.WEB_VITALS]: true,
    },
};
//# sourceMappingURL=sessionWithError.consts.js.map